import { useState } from 'react'
import { BsFillXSquareFill } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'

import { getParentPathname } from '../../../../../util/getParentPathname'
import { fullName } from '../../../../../util/fullName'

import { ContactAddressType } from '../../../../../common/ContactAddress.type'
import userRole from '../../../../../config/userRole'
import { useProcessContactGroup } from '../../../../../hooks/fetch/contactGroup/useProcessContactGroup'
import { selectRole } from '../../../../../slices/authSlice'
import { selectAllContacts } from '../../../../../slices/contactAddressSlice'

const CreateGroup = () => {
  const [groupName, setGroupName] = useState('')
  const [groupAdmin, setGroupAdmin] = useState<ContactAddressType>()
  const [members, setMembers] = useState<ContactAddressType[]>([])

  const navigate = useNavigate()
  const { pathname } = useLocation()

  const prevPathname = getParentPathname(pathname)

  const role = useSelector(selectRole)
  const allContactAddresses = useSelector(selectAllContacts)

  const contactsAdminOption = allContactAddresses
    .filter(
      (contact) =>
        contact.category === 'shared' && contact.contactType === '010',
    )
    .map((contact) => {
      return {
        id: contact.id,
        label: fullName(contact),
        value: [
          contact.lastName,
          contact.firstName,
          contact.lastNameKana,
          contact.firstNameKana,
          contact.contactName,
          contact.id,
        ]
          .filter(Boolean)
          .join(''),
      }
    })

  const contactsOption = allContactAddresses.map((contact) => {
    return {
      id: contact.id,
      label: fullName(contact),
      value: [
        contact.lastName,
        contact.firstName,
        contact.lastNameKana,
        contact.firstNameKana,
        contact.contactName,
        contact.id,
      ]
        .filter(Boolean)
        .join(''),
    }
  })

  const { registContactGroup } = useProcessContactGroup()

  const registeredContactGroup = {
    groupName: groupName,
    groupAdmin: groupAdmin?.id ?? null,
    members: members.map((member) => member.id),
  }

  return (
    <div className="box inner-box stack">
      <span
        className="cursor-pointer upper-right"
        onClick={() => navigate(prevPathname, { replace: true })}
      >
        <BsFillXSquareFill size={'1rem'} />
      </span>
      <span>
        <label htmlFor="groupName" className="d-block">
          グループ名： <span className="text-light bg-danger badge">必須</span>
        </label>
        <input
          type="text"
          id="groupName"
          autoComplete="none"
          style={{ width: '100%' }}
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />
      </span>

      {role === userRole['カンパニー管理者'] && (
        <span className="select:medium">
          <label className="d-block">グループ管理者：</label>
          <Select
            id="groupAdmin"
            options={contactsAdminOption}
            onChange={(e) => {
              const target = allContactAddresses.filter(
                (contact) => contact.id === e?.id,
              )[0]
              setGroupAdmin(target)
            }}
            isSearchable
            isClearable
          />
        </span>
      )}

      <span className="select:medium">
        <label className="d-block">
          メンバー：
        </label>
        <Select
          options={contactsOption}
          onChange={(e) => {
            const addContacts = e.map(
              ({ id }) =>
                allContactAddresses.filter((contact) => contact.id === id)[0],
            )
            setMembers(addContacts.filter(Boolean))
          }}
          isMulti
          isSearchable
          isClearable
        />
      </span>

      <hr />

      <div className="switcher">
        <button
          type="button"
          className="submitButton"
          onClick={(e) => {
            registContactGroup(e, registeredContactGroup, '/contactGroup')
          }}
          disabled={!groupName}
        >
          グループを保存
        </button>

        <button
          type="button"
          className="submitButton btn-danger ms-3"
          onClick={() => navigate('/contactGroup')}
        >
          キャンセル
        </button>
      </div>
    </div>
  )
}

export default CreateGroup
